export default __webpack_public_path__ + "static/elevator-42dd12f10adc1d7fdab41b1e54912ecd.gif";